import React, { useState } from "react";
import { getTodayDate } from "../../../utils";

const DateRangeFilter = ({ onChange }) => {
  const todayStr = getTodayDate();

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [range, setRange] = useState("");

  const emitChange = (from, to) => {
    onChange({ fromDate: from, toDate: to });
  };

  const handleClear = () => {
    setRange("");
    setFromDate("");
    setToDate("");
    emitChange("", "");
  };

  const handleQuickRange = (e) => {
    const value = e.target.value;
    const today = new Date();
    let from = "";
    let to = todayStr;

    switch (value) {
      case "today":
        from = to;
        break;

      case "2_days":
        from = new Date(today.setDate(today.getDate() - 1))
          .toISOString()
          .slice(0, 10);
        break;

      case "3_days":
        from = new Date(today.setDate(today.getDate() - 2))
          .toISOString()
          .slice(0, 10);
        break;

      case "7_days":
        from = new Date(today.setDate(today.getDate() - 6))
          .toISOString()
          .slice(0, 10);
        break;

      case "month":
        from = new Date(today.getFullYear(), today.getMonth(), 1)
          .toISOString()
          .slice(0, 10);
        break;

      case "quarter":
        const qMonth = Math.floor(today.getMonth() / 3) * 3;
        from = new Date(today.getFullYear(), qMonth, 1)
          .toISOString()
          .slice(0, 10);
        break;

      case "year":
        from = new Date(today.getFullYear(), 0, 1)
          .toISOString()
          .slice(0, 10);
        break;

      case "prev_year":
        from = new Date(today.getFullYear() - 1, 0, 1)
          .toISOString()
          .slice(0, 10);
        to = new Date(today.getFullYear() - 1, 11, 31)
          .toISOString()
          .slice(0, 10);
        break;

      default:
        return;
    }

    setRange(value);
    setFromDate(from);
    setToDate(to);
    emitChange(from, to);
  };

  const handleFromDate = (value) => {
    if (toDate && value > toDate) return; // ❌ invalid
    setRange("");
    setFromDate(value);
    emitChange(value, toDate);
  };

  const handleToDate = (value) => {
    if (fromDate && value < fromDate) return; // ❌ invalid
    setRange("");
    setToDate(value);
    emitChange(fromDate, value);
  };

  return (
    <>
      <div className="col-md-4">
        <label className="form-label fw-bold">Quick Filter</label>
        <select className="form-select" value={range} onChange={handleQuickRange}>
          <option value="">Select Range</option>
          <option value="today">Today</option>
          <option value="2_days">Last 2 Days</option>
          <option value="3_days">Last 3 Days</option>
          <option value="7_days">Last 7 Days</option>
          <option value="month">This Month</option>
          <option value="quarter">This Quarter</option>
          <option value="year">This Year</option>
          <option value="prev_year">Previous Year</option>
        </select>
      </div>

      <div className="col-md-3">
        <label className="form-label fw-bold">From Date</label>
        <input
          type="date"
          className="form-control"
          value={fromDate}
          max={todayStr}
          onChange={(e) => handleFromDate(e.target.value)}
        />
      </div>

      <div className="col-md-3">
        <label className="form-label fw-bold">To Date</label>
        <input
          type="date"
          className="form-control"
          value={toDate}
          min={fromDate || undefined}
          max={todayStr}
          onChange={(e) => handleToDate(e.target.value)}
        />
      </div>

      <div className="col-md-2 d-flex align-items-end">
        <button
          className="btn btn-outline-secondary w-100"
          onClick={handleClear}
          disabled={!fromDate && !toDate && !range}
        >
          Clear
        </button>
      </div>
    </>
  );
};

export default DateRangeFilter;
